import { style } from '@vanilla-extract/css'

const screenContainer = style({
  backgroundColor: '#F2F1EF',
  fontFamily: 'Noto Sans JP Variable, sans-serif',
  color: '#252525',
  width: '100%',
  padding: '88px 24px',
})

const pageContainer = style({
  maxWidth: '540px',
  margin: '0 auto',
  '@media': {
    '(min-width: 960px)': {
      width: '440px',
    },
  },
})

const addressContainer = style({
  position: 'relative',
  overflow: 'hidden',
})

const addressDetail = style({
  height: '0px',
})

const formHeading = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontWeight: '700',
  fontSize: '19px',
  lineHeight: '1.5',
})

const formSubheading = style([
  formHeading,
  {
    fontSize: '13px',
    color: '#828282',
  },
])

const input = style({
  width: '100%',
  height: '44px',
  padding: '0 12px',
  borderRadius: '8px',
  border: '0.5px solid #00000014',
  backgroundColor: 'white',
  boxShadow: '0px 0px 4px 0px #1230480A',
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  selectors: {
    '&:focus-visible': {
      outline: '1px solid #E46327',
      outlineOffset: '-1px',
      boxShadow: 'none',
    },
  },
})

const inputError = style({
  color: '#ED0006',
  fontSize: '11px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const checkbox = style({
  margin: '8px 0',
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const legal = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const warn = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '2%',
  color: '#ED0006'
})

const warnIcon = style({
  width: '16px',
  height: '21px'
})

const checkoutError = style({
  color: '#ED0006',
  fontSize: '13px',
  lineHeight: '1.5',
})

const nutrientBanner = style({
  width: '100%',
  borderRadius: '16px',
  cursor: 'pointer',
})

export const styles = {
  screenContainer,
  pageContainer,
  addressContainer,
  addressDetail,
  formHeading,
  formSubheading,
  input,
  inputError,
  checkbox,
  legal,
  warn,
  warnIcon,
  checkoutError,
  nutrientBanner,
}
